import styled from 'styled-components'
import TypographyPrimary from 'components/Typography/Primary'
import TypographySecondary from 'components/Typography/Secondary'
import { Doc } from 'share-ui/components/Icon/Icons'
import { StyledRow } from '../Subnets/Cortext/Settings/SettingsStyles.css'

import { ButtonTertiary } from 'components/Button/Button'
import { useSubnetById } from 'services/subnetApiService/useSubnetApiService'
import { useParams } from 'react-router-dom'

const formatNumber = (num: number): string => {
    if (num >= 1000000) {
        return `${(num / 1000000).toFixed(num % 1000000 === 0 ? 0 : 1)}M`
    } else if (num >= 1000) {
        return `${(num / 1000).toFixed(num % 1000 === 0 ? 0 : 1)}k`
    }
    return num.toString()
}

const SubnetDescription = ({
    description,
    title,
    docUrl,
    noImage,
    noText,
}: {
    title: string
    description: string
    docUrl: string
    noImage?: boolean
    noText?: boolean
}) => {
    const { id: subnet_id } = useParams()
    const { data: subnet_data } = useSubnetById(subnet_id)

    return (
        <StyledTitle>
            <StyledRow>
                <TypographyPrimary value={title} size='large' semiBold />

                <StyledRow>
                    <ButtonTertiary size={'small'} onClick={() => window.open(docUrl, '_blank')}>
                        <StyledDoc size={14} />
                        <TypographySecondary value='Docs' size='xs-small' />
                    </ButtonTertiary>
                </StyledRow>
            </StyledRow>

            <TypographySecondary value={description} size='xs-small' />

            {subnet_data?.length !== 0 && (
                <>
                    {!noText && (
                        <StyledPriceTag>
                            <TypographyPrimary
                                value={`$${subnet_data?.price_per_token}`}
                                bold
                                size='xs-small'
                            />
                            <TypographySecondary
                                value={`/ ${formatNumber(subnet_data?.limit) || 0} tokens`}
                                size='xs-small'
                                semiBold
                            />
                        </StyledPriceTag>
                    )}

                    {!noImage && (
                        <StyledPriceTag>
                            <TypographyPrimary
                                value={`$${subnet_data?.price_per_request}`}
                                bold
                                size='xs-small'
                            />
                            <TypographySecondary value={`/ Image`} size='xs-small' semiBold />
                        </StyledPriceTag>
                    )}
                </>
            )}
        </StyledTitle>
    )
}

export default SubnetDescription

const StyledTitle = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    padding-bottom: 16px;

    border-bottom: ${({ theme }) => ` ${theme.body.secondaryBorder}`};
`

const StyledPriceTag = styled.div`
    border-radius: 10px;
    border: 2px solid ${({ theme }) => ` ${theme.body.secondaryBorderBackground}`};
    padding: 4px 8px;

    margin-top: 8px;

    width: fit-content;

    display: flex;
    align-items: center;
    gap: 4px;
`
const StyledDoc = styled(Doc)`
    color: ${({ theme }) => theme.body.textColorSecondary};
`
